package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.estimate_is_external_contract
import com.nonopn.skywatcher.common.app.res.estimate_is_external_contract_explanation
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.utils.localized
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.TextNormal

@Composable
fun EstimateIsExternalContract(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    val state by model.states.collectAsState()

    println("state ?? ${state.isExternalContract}")

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        TextNormal(
            modifier = Modifier.weight(1f),
            text = Res.string.estimate_is_external_contract.localized(),
            fontSize = LocalFontSizes.current.map.activityLightning
        )

        Checkbox(
            checked = state.isExternalContract,
            onCheckedChange = {
                model.setIsExternalContract(it)
            }
        )
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        TextNormal(
            text = Res.string.estimate_is_external_contract_explanation.localized(),
            fontStyle = FontStyle.Italic,
            fontSize = LocalFontSizes.current.map.activityLightning,
        )
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun Preview() {
    HotPreviewApp(
        Modifier.fillMaxSize().padding(10.dp),
        isDarkTheme = isSystemInDarkTheme()
    ) {
        EstimateIsExternalContract(
            Modifier.fillMaxSize(),
            FakeEstimateScreenModel()
        )
    }
}
